exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.select2-container--disabled .select2-hide-arrow .select2-selection__arrow b{\n    display:none !important;\n}\n", ""]);
